import React from 'react'

import { Svg } from './Vibing/styles'

export default function VibeLogo({ id = 'vibe-logo' }) {
    return (
        <Svg
            width="226"
            height="118"
            viewBox="0 0 226 118"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g filter={`url(#${id})`}>
                <path
                    filter={`url(#${id})`}
                    d="M10 80.4502C15.383 82.3177 19.1856 84.4583 23.9124 87.3469C27.361 89.4544 31.971 90.3447 35.1493 92.8167C38.7701 95.6329 45.316 99.149 45.316 92.6978C45.316 85.3402 45.2081 77.4993 41.8676 70.8185C40.6414 68.3659 36.5714 60.5072 39.7273 67.608C41.6094 71.8429 42.773 75.0993 47.9915 75.0993C52.8045 75.0993 51.7371 68.6621 51.7371 64.9325C51.7371 60.9281 45.6101 51.1 49.0022 56.4305C52.498 61.924 55.5347 68.2429 60.8337 72.3643C70.464 79.8546 70.881 66.6878 71.0004 59.2843C71.2084 46.3878 76.0705 29.1683 69.0978 17.5472C64.9748 10.6755 57.3615 7.333 54.1153 17.0716C51.2717 25.6023 59.9518 33.4791 63.0335 40.6156C66.1627 47.8623 83.4494 77.0748 90.8582 62.2571C92.7912 58.3911 95.047 44.8956 88.5989 43.0532C84.1957 41.7952 79.4223 47.1 78.5511 51.0202C76.9594 58.183 92.7013 50.6742 94.3066 49.6527C97.2892 47.7547 100.747 43.5006 100.965 39.7832C101 39.2009 100.934 45.0406 100.965 46.4422C101.128 53.5931 103.834 62.0339 106.733 68.4403C106.908 68.828 110.235 78.268 111.667 73.9696C113.784 67.6205 116.916 61.564 118.029 54.8847C118.83 50.0797 120.229 35.5659 120.229 40.4372C120.229 51.7937 122.207 61.8703 123.439 72.9589C123.498 73.485 124.461 64.1891 124.747 62.2571C125.764 55.3917 127.014 49.1072 130.931 43.2316C136.488 34.8957 137.334 55.335 138.422 58.2142C144.15 73.3774 159.762 62.2419 169.457 55.836C175.21 52.0352 185.362 39.2666 173.738 36.0376C166.192 33.9415 161.262 38.2841 157.745 44.6585C156.172 47.5093 151.972 56.0912 153.523 59.5816C154.714 62.2596 160.82 61.1869 163.096 61.1869C169.186 61.1869 171.703 56.6937 173.143 51.1391C173.399 50.1546 175.878 40.3287 175.878 45.2531C175.878 51.605 174.808 57.9357 174.808 64.3974C174.808 73.9476 174.926 83.5054 174.808 93.0545C174.753 97.5013 174.346 102.457 170.29 105.064C160.023 111.664 144.843 104.202 144.843 92.2222C144.843 78.0999 172.614 78.3098 182.062 78.3098C189.41 78.3098 201.739 76.1285 208.222 80.4502C210.628 82.0547 215.302 84.3845 216.545 86.8713"
                    stroke="white"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <path
                filter={`url(#${id})`}
                d="M100.965 19.4499C99.8004 22.4352 96.2312 30.3163 102.155 31.1625C106.086 31.724 109.365 31.2649 112.143 28.487C115.761 24.8688 109.788 21.3497 107.387 20.2823C104.427 18.9668 100.992 19.4499 97.7549 19.4499"
                stroke="white"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                filter={`url(#${id})`}
                d="M41.0354 35.502C39.8826 39.0323 36.724 44.7586 37.8843 48.8198C38.3255 50.3642 43.8589 49.5243 44.4837 48.3441C48.0863 41.5393 38.5057 42.2147 36.7546 38.7125"
                stroke="white"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <defs>
                {/* NEON FILTER */}
                <filter
                    id={id}
                    x="-20%"
                    y="-20%"
                    width="140%"
                    height="140%"
                    filterUnits="objectBoundingBox"
                    primitiveUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feDropShadow
                        stdDeviation="6 6"
                        in="SourceGraphic"
                        dx="0"
                        dy="0"
                        floodColor="#f400dc"
                        floodOpacity="1"
                        x="0%"
                        y="0%"
                        width="100%"
                        height="100%"
                        result="dropShadow"
                    />
                </filter>
                {/* NEON FILTER */}

                <filter
                    id={id}
                    x="4.49963"
                    y="9.5"
                    width="217.546"
                    height="107.528"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow"
                        result="shape"
                    />
                </filter>
            </defs>
        </Svg>
    )
}
